$shm_hitalama_audio_player $mol_view
	uri \
	name \
	playing? false
	time? 0
	slider_time? 0
	duration 0
	sub /
		<= Audio $mol_view
			dom_name \audio
			attr *
				^
				src <= uri
				preload \metadata
				aria-label <= name
			event *
				^
				timeupdate? <=> sync_time? null
				loadedmetadata? <=> sync_duration? null
				durationchange? <=> sync_duration? null
				seeked? <=> sync_duration? null
				play? <=> sync_playing? null
				pause? <=> sync_playing? null
				ended? <=> sync_end? null
		<= Play $yuf_video_play
			checked? <=> playing?
		<= Slider $yuf_video_slider
			value? <=> slider_time?
			value_max <= duration
			step 0.001
		<= Time $yuf_video_estimate
			time <= time
			duration <= duration
